export default "__VITE_ASSET__74244f86__"